import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export function getAllGater() {
  return axiosUtils.GetAll(api.GET_ALL_GATER_URL);
}
